"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS = exports.CountryId = void 0;
var CountryId;
(function (CountryId) {
    CountryId[CountryId["NL"] = 15] = "NL";
    CountryId[CountryId["DE"] = 7] = "DE";
    CountryId[CountryId["BE"] = 3] = "BE";
    CountryId[CountryId["LU"] = 14] = "LU";
    CountryId[CountryId["FR"] = 9] = "FR";
    CountryId[CountryId["US"] = 20] = "US";
    CountryId[CountryId["GB"] = 19] = "GB";
    CountryId[CountryId["GG"] = 88] = "GG";
    CountryId[CountryId["JE"] = 116] = "JE";
    CountryId[CountryId["IE"] = 12] = "IE";
    CountryId[CountryId["AU"] = 2] = "AU";
    CountryId[CountryId["NZ"] = 17] = "NZ";
    CountryId[CountryId["BFPO"] = 245] = "BFPO";
    CountryId[CountryId["CZ"] = 69] = "CZ";
})(CountryId || (exports.CountryId = CountryId = {}));
var PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS;
(function (PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS) {
    PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS["public_site"] = "public_site";
    PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS["shoplanding"] = "shoplanding";
})(PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS || (exports.PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS = PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS = {}));
//# sourceMappingURL=GeneralTypes.js.map